import { clsx } from 'clsx';

import type { InputHTMLAttributes } from 'react';

import styles from './RadioButton.module.css';

export interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  /** The id of the element. */
  id: string;
  /** The label of the radio button. */
  label: string;
  /** The description that is shown under the label. */
  description?: string;
  /** The gap between the label and radio button. */
  gap?: 'normal' | 'large';
}

/** Represents a component for a radio button. */
export const RadioButton = ({ id, label, gap = 'normal', description, ...restProps }: RadioButtonProps) => (
  <div className={clsx(styles['radio-button'], styles[`radio-button--gap-${gap}`])}>
    <input
      className={styles['radio-button__input']}
      {...restProps}
      id={id}
      type="radio"
      aria-describedby={description ? `${id}-description` : undefined}
    />
    <label className={styles['radio-button__label']} htmlFor={id}>
      {label}
    </label>
    {description && (
      <p id={`${id}-description`} className={styles['radio-button__description']}>
        {description}
      </p>
    )}
  </div>
);
